import { Schema as S } from "effect";
export const Schema = S.String.pipe(S.minLength(1), S.maxLength(255), S.brand("@open-revenue/schema/OriginalAppUserId"), S.annotations({
    description: "The original app user ID from the initial subscription purchase, typically from Stripe metadata"
}));
export const Type = Schema.Type;
export const make = (id)=>S.decodeUnknown(Schema)(id);
export const makeUnsafe = (id)=>id;
export const NullableSchema = S.NullOr(Schema);
